module.exports = __webpack_public_path__ + "img/batch_stay.d19832ac.png";